import { useMemo } from 'react';
import { currencyCode } from '../../utils/currency';
import { useLocale } from '../../context';
import { useResponsibleLimits } from '../../hooks/useResponsibleLimits';
import { summarizeDepositLimit, summarizeSessionLimit } from '../../utils/responsibleLimits';

function IconChevronRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function formatDepositAmount(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  const grouped = String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${grouped} ${currencyCode()}`;
}

export default function MobileAccountResponsible({ onOpenDeposit, onOpenSession }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const { limits } = useResponsibleLimits();

  const depositInfo = useMemo(
    () => summarizeDepositLimit(limits?.deposit?.current, tr, formatDepositAmount),
    [limits?.deposit?.current, tr],
  );

  const sessionInfo = useMemo(
    () => summarizeSessionLimit(limits?.session?.current, tr),
    [limits?.session?.current, tr],
  );

  const items = [
    { id: 'deposit', label: tr('account.responsible.tabDeposit'), info: depositInfo, onClick: onOpenDeposit },
    { id: 'session', label: tr('account.responsible.tabSession'), info: sessionInfo, onClick: onOpenSession },
  ];

  return (
    <div className="mobile-account-responsible widget responsible">
      <div className="mobile-account-responsible__table table">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className="mobile-account-responsible__item table-item"
            onClick={item.onClick}
          >
            <span className="mobile-account-responsible__caption-wrap caption-container">
              <span className="mobile-account-responsible__caption caption">{item.label}</span>
              {item.info ? (
                <span className="mobile-account-responsible__limit-info limit-info">{item.info}</span>
              ) : null}
            </span>
            <span className="mobile-account-responsible__chevron" aria-hidden="true">
              <IconChevronRight />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
